import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AuditHistoryService } from '../../services/audit-history.service';
import { SolutionEstimateAuditOp, solutionEstimateKeys } from '../../../main/content/apps/utils';
import { CommonOrdersService } from '../../../main/content/apps/e-commerce/orders/commonOrders.service';
import { OrderStatus } from '../../../main/content/apps/e-commerce/orders/orders.service';

@Component({
    selector: 'view-logs',
    templateUrl: './view-logs.component.html',
    styleUrls: ['./view-logs.component.scss']
})
export class ViewLogsDialogComponent {

    allStatus: OrderStatus[];
    auditLogData: any = [];
    solutionEstimateKeys = solutionEstimateKeys;
    SolutionEstimateAuditOp = SolutionEstimateAuditOp;
    auditLoader = true;
    constructor(
        public dialogRef: MatDialogRef<ViewLogsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        public auditHistoryService: AuditHistoryService,
        public commonOrdersService: CommonOrdersService,
    ) {
    }

    ngOnInit() {

        this.getAllStatus();
        this.fetchAuditLogsByOrderId();
    }

    fetchAuditLogsByOrderId() {
        this.auditHistoryService.fetchLogsByOrderId(this.data.orderId, SolutionEstimateAuditOp).then((auditLogRes: any) => {

            this.auditHistoryService.formatAuditLogData(auditLogRes).then((formatRes) => {
                this.auditLogData = formatRes;
                this.auditLoader = false;
            })

        }).catch((auditLogErr) => {
            console.log(" auditLogErr", auditLogErr);
            this.auditLoader = false;
        });
    }

    getAllStatus() {
        this.commonOrdersService.listOfStatusAll.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });
    }

    getStatusName(data) {
        if (data && data.length > 0 && data[0].value) {
            let status = this.allStatus.find(type => type.statusId === data[0].value);
            return status && status['displayStatus'] ? status['displayStatus'] : '';
        }
        else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/core/components/view-logs/view-logs.component.ts